import React from 'react';
import { Reveal } from './Reveal';
export function ProofSection() {
  return <section className="py-14 px-6 bg-white" data-id="element-231">
      <Reveal data-id="element-232">
        <span className="inline-block text-[10px] font-semibold tracking-[0.14em] uppercase text-sage mb-3" data-id="element-233">
          Lo que dicen
        </span>
        <h2 className="font-serif text-[34px] font-semibold leading-[1.15] text-ink mb-6" data-id="element-234">
          Mujeres que
          <br data-id="element-235" />
          ya lo <em className="italic text-terra" data-id="element-236">tienen</em>
        </h2>

        <div className="flex flex-col gap-3.5" data-id="element-237">
          <Reveal delay={100} data-id="element-238">
            <div className="bg-white rounded-2xl p-5 border border-cream-dark" data-id="element-239">
              <div className="text-gold text-[14px] mb-2" data-id="element-240">★★★★★</div>
              <p className="font-serif text-[16px] leading-[1.6] text-ink-soft italic mb-2.5" data-id="element-241">
                "Por primera vez entendí por qué me sentía así antes de cada
                período. Tenía nombre y tenía solución."
              </p>
              <p className="text-[12px] font-semibold text-ink" data-id="element-242">
                Lucía M. — Buenos Aires
              </p>
            </div>
          </Reveal>

          <Reveal delay={200} data-id="element-243">
            <div className="bg-white rounded-2xl p-5 border border-cream-dark" data-id="element-244">
              <div className="text-gold text-[14px] mb-2" data-id="element-245">★★★★★</div>
              <p className="font-serif text-[16px] leading-[1.6] text-ink-soft italic mb-2.5" data-id="element-246">
                "El test me identificó como perfil SOP insulinorresistente.
                Llevé esa info a mi médica y por fin tuvimos una conversación
                real."
              </p>
              <p className="text-[12px] font-semibold text-ink" data-id="element-247">
                Andrea R. — Córdoba
              </p>
            </div>
          </Reveal>

          <Reveal delay={300} data-id="element-248">
            <div className="bg-white rounded-2xl p-5 border border-cream-dark" data-id="element-249">
              <div className="text-gold text-[14px] mb-2" data-id="element-250">★★★★★</div>
              <p className="font-serif text-[16px] leading-[1.6] text-ink-soft italic mb-2.5" data-id="element-251">
                "Estaba segura de que lo que me pasaba era menopausia pero nadie
                me lo había explicado así. El capítulo 5 me cambió la cabeza."
              </p>
              <p className="text-[12px] font-semibold text-ink" data-id="element-252">
                Valeria T. — Rosario
              </p>
            </div>
          </Reveal>
        </div>
      </Reveal>
    </section>;
}